// extracted by mini-css-extract-plugin
export default {"tableBodyCell":"TableReportCalls_tableBodyCell__KKmiy","tableContainer":"TableReportCalls_tableContainer__Zp-7e"};